import { FC, memo } from 'react';
import ReactMarkdown, { Options } from 'react-markdown';

/**
 * MemoizedReactMarkdown component is a memoized version of ReactMarkdown for
 * performance optimization. Prevents unnecessary re-renders when props haven't changed.
 * Accepts all standard ReactMarkdown options.
 * 
 * @component
 * @param {Options} props - ReactMarkdown options (children, remarkPlugins, rehypePlugins, etc.)
 * @returns {JSX.Element} Rendered markdown content
 * 
 * @example
 * ```tsx
 * <MemoizedReactMarkdown
 *   remarkPlugins={[remarkGfm]}
 *   rehypePlugins={[rehypeKatex]}
 * >
 *   {markdownContent}
 * </MemoizedReactMarkdown>
 * ```
 */
export const MemoizedReactMarkdown: FC<Options> = memo(ReactMarkdown);
